/* eslint-disable vue/require-v-for-key */
/* eslint-disable vue/valid-v-for */
<template>
	<div class="company-id-uploader">
		<div class="choose-file">
			<label for="chooseFile">Upload from file (*.xlsx, *.csv, *.txt)</label>
			<div>
				<input id="chooseFile" name="chooseFile" type="file" ref="fileInput" />

				<div v-on:click.prevent="loadFile()">
					<input-button :btn-class="'btn-grey'">Load file <font-awesome-icon icon="upload" /></input-button>
				</div>
			</div>
		</div>

		<div class="uploaded-files" v-if="getUploadedFiles.length > 0">
			<h4>Uploaded files</h4>
			<ul class="no-style-list clear">
				
				<li v-for="file in getUploadedFiles" :key="file">{{file.fileName}} ({{file.companyNumbers.length}} company numbers) <button class="fake-anchor" aria-label="Remove uploaded file" @click.prevent="removeFile(file.fileName)">X</button></li>
			</ul>
		</div>
	</div>
</template>

<script>
/* eslint-disable no-unused-vars */

	import _ from 'lodash';
	import { mapState, mapActions } from 'vuex'
	import InputButton from './InputButton'
	import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';

	export default {
		name: 'CompanyIdUploader',
		data() {
			return {				
				//uploadedFiles: []				
			}
		},
		components: {
			InputButton,
			FontAwesomeIcon
		},
		computed: {
			...mapState({
				lastFileUpload: state => state.fileuploadmodule.lastFileUpload
			}),
			getUploadedFiles: function () {
				return this.uploadedFiles;
			}
		},
		props: ['uploadedFiles'],
		created() {
			
		},
		methods: {
			...mapActions('fileuploadmodule', [
				'uploadFileOfCompanyIds'
			]),
			loadFile() {
				var formData = new FormData();
				var totalFiles = this.$refs.fileInput.files.length;

				for (var i = 0; i < totalFiles; i++) {
					var file = this.$refs.fileInput.files[i];
					formData.append('file', file);
				}

				this.uploadFileOfCompanyIds(formData).then(() => {
					let fileFound = false;
					for (let file of this.uploadedFiles) {
						if (_.isMatch(file, { 'filename': this.lastFileUpload.filename })) fileFound = true;
					}
					if (!fileFound) {
						this.uploadedFiles.push({ 'fileName': this.lastFileUpload.fileName, 'extension': this.lastFileUpload.extension, 'companyNumbers': this.lastFileUpload.companyNumbers });
						this.$emit('arrayChanged', this.uploadedFiles)
					}
                    this.$emit('close');
				}).catch(err => {
					this.$emit('showError', { header: 'Error', body: 'There was an error reading the file uploaded'});
				});
			},
			removeFile(filename) {
				for (let file of this.uploadedFiles) {
					if (_.isMatch(file, { 'fileName': filename })) {
						for (var i = 0; i < this.uploadedFiles.length; i++) {
							if (this.uploadedFiles[i].fileName === filename) {
								this.uploadedFiles.splice(i, 1);
								this.$emit('arrayChanged', this.uploadedFiles);
								break;
							}
						}
					}
				}
			},
            
		}
	}
</script>

<style lang="scss" scoped>
    .choose-file {
		input {
			display: block;
			margin-top: 10px;
			margin-bottom: 20px;
		}

		@media only screen and (min-width: 800px) {
			input {
				margin-bottom: 0;
			}
			div {
				display: flex;
			}
		}
	}

	.uploaded-files{
		margin-bottom:30px;

		h4{
			margin-bottom:5px;
		}

		ul{
			margin-top:0;
		}
	}
</style>
